import { bind, Do, Either, fold, fromPredicate, right } from 'fp-ts/Either'
import { flow, pipe } from 'fp-ts/function'
import React from 'react'
import ReactDOM from 'react-dom'

import { isNotEmpty } from '../lib/guard'
import { observeBodyResize } from '../lib/iframe'
import { App } from './App'

interface QueryParams {
  aspectRatio: string | null
  // opaque id provided by parent to include in callback message
  id: string
  // for targeting single origin in postMessage
  parentOrigin: string
  wistiaShareUrl: string
}

function parseParams(): Either<string, QueryParams> {
  const params = new URLSearchParams(window.location.search)
  const getParam = (name: string) => () => params.get(name)
  return pipe(
    Do,
    bind('aspectRatio', flow(getParam('r'), right)),
    bind(
      'id',
      flow(
        getParam('id'),
        fromPredicate(isNotEmpty, () => 'id not specified')
      )
    ),
    bind(
      'parentOrigin',
      flow(
        getParam('o'),
        fromPredicate(isNotEmpty, () => 'Parent origin not specified')
      )
    ),
    bind(
      'wistiaShareUrl',
      flow(
        getParam('w'),
        fromPredicate(isNotEmpty, () => 'Wistia URL not specified')
      )
    )
  )
}

pipe(
  parseParams(),
  fold(
    (message) => {
      console.error(message)
    },
    (queryParams) => {
      window.addEventListener('load', () => observeBodyResize(queryParams))
      const app = document.getElementById('app')
      ReactDOM.render(React.createElement(App, queryParams), app)
    }
  )
)
